import { render, staticRenderFns } from "./ServiceHighlight.vue?vue&type=template&id=d95a343e"
import script from "./ServiceHighlight.vue?vue&type=script&lang=ts"
export * from "./ServiceHighlight.vue?vue&type=script&lang=ts"
import style0 from "./ServiceHighlight.vue?vue&type=style&index=0&id=d95a343e&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Block: require('/app/components/generic/Block.vue').default,Icon: require('/app/components/vantone/Icon.vue').default})
